// extracted by mini-css-extract-plugin
export default {"root":"Input_root__wSKOd","inputDiv":"Input_inputDiv__ebzmt","background":"Input_background__Az5V7"};